import React, { useState } from 'react';
import { arrayOf, bool, string, node, oneOfType } from 'prop-types';
import Wrapper from '../Wrapper';
import SectionHeader from '../SectionHeader';

const CollapsibleContainer = ({
  headerTitle,
  headerSubTitle,
  children,
  isOpen,
  className,
}) => {
  const [isOpening, setIsOpening] = useState(isOpen);

  const toggleVisibility = () => {
    setIsOpening(!isOpening);
  };

  return (
    <Wrapper width="100%" className={className}>
      <SectionHeader
        title={headerTitle}
        subtitle={headerSubTitle}
        isOpen={isOpening}
        onClick={toggleVisibility}
      />
      {isOpening ? children : null}
    </Wrapper>
  );
};

CollapsibleContainer.propTypes = {
  headerTitle: string,
  headerSubTitle: string,
  children: oneOfType([node, arrayOf(node)]),
  isOpen: bool,
  className: string,
};

export default CollapsibleContainer;
